<template>
  <q-dialog
    ref="dialog"
    persistent
    transition-show="fade-in"
    transition-hide="fade-out"
    @hide="onDialogHide"
  >
    <q-card
      :style="{ width: '560px' }"
      class="q-dialog-plugin q-mx-md"
    >
      <q-card-section class="row items-center">
        <div class="text-h6">
          Select Items for Delivery Now
        </div>
        <q-space />
        <q-btn
          icon="close"
          dense
          flat
          round
          @click="onCancelClick"
        />
      </q-card-section>
      <q-card-section>
        <model-table
          :collection="order.orderItems"
          :filter-by-data-array="orderItems"
          selection="multiple"
          :columns="[
            { field: 'id', hide: $consumer },
            { field: 'type', component: OrderItemTypeCell },
            { field: 'state', component: OrderStateCell },
            { field: 'description', maxWidth: '250px' },
            { field: 'total', component: 'money' }
          ]"
          :show-add="false"
          :show-edit="false"
          row-key="id"
          :initial-selection="selected"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        />
      </q-card-section>
      <q-card-section class="row items-center q-gutter-md">
        <q-btn
          size="xl"
          class="col"
          color="primary"
          :loading="placing"
          :disable="placing || orderItems.length === 0"
          @click="onOKClick"
        >
          Deliver Now
        </q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import { date } from 'quasar'
import ModelTable from 'src/modules/admin/components/ModelTable'
const { addToDate } = date
import { IsoDateTime } from 'src/models/model'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'DeliveryModifierDialog',
  components: {
    ModelTable
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    allowPlaceOrder: {
      type: Boolean,
      default: true
    }
  },
  emits: ['hide', 'ok'],
  data () {
    return {
      selected: [],
      placing: false
    }
  },
  computed: {
    orderItems () {
      return _.filter(this.order.orderItems.data, (orderItem) =>
        _.includes(['paid', 'placed'], orderItem.state) &&
        orderItem.hasDueTime &&
        !orderItem.preparedAt &&
        (orderItem.dueTime == null || orderItem.dueTime > addToDate(new IsoDateTime(), { minutes: 1 }))
      )
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      OrderStateCell
    })
  },
  methods: {
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    onDialogHide () {
      this.$emit('hide')
    },
    async onOKClick () {
      _.each(this.orderItems, orderItem => {
        orderItem.pickPrepPrintedAt = null
      })
      _.each(this.selected, orderItem => {
        orderItem.hasDueTime = false
      })
      this.placing = true
      await this.allowPlaceOrder ? this.order.place() : this.order.save()
      this.placing = false
      this.$emit('ok')
      this.hide()
    },
    onCancelClick () {
      this.hide()
    }
  }
}
</script>
